import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class CustomNameComponent extends Component {
  static readonly TYPE_ID: string = '69bea39bd81344beb9866c47caa3333b';

  constructor(
    public readonly firstName: string | null,
    public readonly lastName: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return CustomNameComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): CustomNameComponent {
    return new CustomNameComponent(
        MapUtils.getOrNull<string>(map, 'firstName'),
        MapUtils.getOrNull<string>(map, 'lastName'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'firstName': this.firstName,
      'lastName': this.lastName,
    };
  }

  clone(): this {
    return new CustomNameComponent(
        this.firstName,
        this.lastName,
    ) as this;
  }

  isSame(other: CustomNameComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.firstName === this.firstName && other.lastName === this.lastName;
  }
}

export class CustomNameComponentBuilder extends DataModelBuilder<CustomNameComponent> {
  build(context: SerializationContext, map: SerializedData): CustomNameComponent {
    return CustomNameComponent.fromMap(context, map);
  }
}
